import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { content } from '../data/content';
import { Section } from './ui/Section';
import { Reveal } from './ui/Reveal';
import { Icon } from './ui/Icon';

const STEP_ICONS = ['compass', 'layers', 'rocket', 'shield'];

export const Process = () => {
  const { language } = useLanguage();
  const t = content[language];
  return (
    <Section
      id="process"
      eyebrow={t.process.eyebrow}
      title={t.process.title}
      subtitle={t.process.subtitle}
      align="center"
      className="bg-elev"
    >
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 relative">
        {/* Connector line */}
        <div
          className="hidden lg:block absolute top-12 left-[12.5%] right-[12.5%] h-px"
          style={{
            background:
              'linear-gradient(90deg, var(--border-strong), var(--brand), var(--accent), var(--border-strong))',
          }}
        />

        {t.process.steps.map((step, i) => (
          <Reveal key={step.n} delay={120 * i}>
            <div
              className="relative rounded-3xl border bg-surface p-6 lift h-full"
              style={{ borderColor: 'var(--border)' }}
            >
              <div className="flex items-center justify-between">
                <span className="text-mono text-xs tracking-[0.25em] text-subtle">{step.n}</span>
                <span
                  className="inline-flex items-center justify-center h-10 w-10 rounded-2xl text-white"
                  style={{
                    background:
                      i === 0
                        ? 'var(--brand)'
                        : i === 1
                        ? 'color-mix(in oklab, var(--brand) 60%, var(--accent))'
                        : i === 2
                        ? 'var(--accent)'
                        : 'var(--mint)',
                  }}
                >
                  <Icon name={STEP_ICONS[i]} size={18} />
                </span>
              </div>
              <h3 className="mt-5 text-display text-xl font-bold text-app">{step.title}</h3>
              <p className="mt-2 text-sm text-muted leading-relaxed">{step.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </Section>
  );
};

export default Process;
